var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{staticClass:"image-preview",style:({
    transform: `scale(${_setup.props.zoom}) rotate(${_setup.props.rotate}deg)`,
  }),attrs:{"src":_setup.props.src}})
}
var staticRenderFns = []

export { render, staticRenderFns }